import { AspectRatio, AspectRatioProps, Image } from "@chakra-ui/react";
import { filestoreUrl } from "config";
import { ImageSize } from "types";

type TraitImageProps = Omit<AspectRatioProps, "ratio" | "color"> & {
  tokenId: number;
  color: number;
  size?: ImageSize;
  isDisabled?: boolean;
};

const TraitImage = ({
  tokenId,
  color,
  size = "512",
  isDisabled = false,
  ...rest
}: TraitImageProps) =>
  tokenId !== 0 ? (
    <AspectRatio ratio={1} w="full" {...rest}>
      <Image
        src={`${filestoreUrl}/elements/${tokenId}_${color}_${size}.png`}
        fit="cover"
        transition="opacity 0.15s"
        alt={`${tokenId}`}
      />
    </AspectRatio>
  ) : null;

export default TraitImage;
